import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import { SliderGenProps } from "../../../../../src/types/Interface";
import { eventBus, EnumEventBus } from "./EventBus";
import { SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";


const SliderGen: SliderGenProps[] = [
  {
    head: "move diameter",
    colors: {
      bgColor: 0x21D4FE,
      barColor: 0x000000,
      buttonColor: 0x21D4FE
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveDiameter, v - 100)
  },
  {
    head: "move circumference",
    colors: {
      bgColor: 0xB5A1FF,
      barColor: 0x000000,
      buttonColor: 0xB5A1FF
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveCircum, v - 100)
  },
  {
    head: "rotate circle",
    colors: {
      bgColor: 0xBFBFBF,
      barColor: 0x000000,
      buttonColor: 0x000000
    },
    onUpdate: (v: number) => eventBus.emit(EnumEventBus.rotateCircle, v - 100)
  },
]


export default class SliderManager extends BaseSliderManager {
  constructor() {
    super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
  }
}